/** Slow scroll speed for unattended TV/office displays (pixels per second). */
export const SQUAD_TV_SCROLL_PIXELS_PER_SECOND = 30;

/** Server max page size for group leaderboard (`competitionsGroupLeaderboard.routes.js`). */
export const SQUAD_TV_LEADERBOARD_PAGE_LIMIT = 200;

/** Fixed row height for the Stadium board's dense dual-column rows (px). */
export const SQUAD_TV_STADIUM_ROW_HEIGHT = 56;

/** Avatar diameter for a Stadium-board row (px). */
export const SQUAD_TV_STADIUM_AVATAR_SIZE = 38;

/**
 * Design tokens specific to the dark Stadium scoreboard (subtle translucent
 * lines/stripes the global theme has no equivalent for). Kept here so the
 * style files reference named tokens instead of inline magic colors.
 */
export const SQUAD_TV_STADIUM_COLORS = {
  rowAlt: 'rgba(255,255,255,0.022)',
  border: 'rgba(255,255,255,0.07)',
  borderStrong: 'rgba(255,255,255,0.12)',
} as const;

/** Max gap between banner taps to count as a double-tap exit. */
export const SQUAD_TV_EXIT_DOUBLE_PRESS_WINDOW_MS = 400;

/** How long the exit hint stays fully visible before fading out. */
export const SQUAD_TV_EXIT_HINT_VISIBLE_MS = 5000;

/** Fade-out duration for the exit hint. */
export const SQUAD_TV_EXIT_HINT_FADE_MS = 800;

export const SQUAD_TV_MODE_COPY = {
  ENTER_TV_MODE: 'TV display',
  EXIT_TV_MODE: 'Exit TV',
  ENTER_TV_MODE_A11Y: 'Enter TV display mode for squad leaderboard',
  EXIT_TV_MODE_A11Y: 'Exit TV display mode',
  EXIT_TV_DOUBLE_TAP_HINT: 'Double-tap banner to exit',
  EXIT_TV_ESCAPE_HINT: 'or press Esc',
  EXIT_TV_BANNER_A11Y: 'Double-tap banner to exit TV display mode',
  MEMBERS: 'members',
  EMPLOYEES: 'members',
} as const;

export const SQUAD_TV_STADIUM_COPY = {
  PRIZE_LABEL: 'Top 3 win',
  COMPANY_GROUP: 'Company Group',
  MEMBERS: 'members',
} as const;

export const SQUAD_TV_MODE_TEST_IDS = {
  toggle: 'squad-tv-mode-toggle',
  /** Compact Stadium-board top bar (branding, live pill, prize, clock, mascot). */
  header: 'squad-tv-header',
  /** Pressable wrapper — double-tap to exit TV mode. */
  bannerPressTarget: 'squad-tv-banner-press-target',
  exitHint: 'squad-tv-exit-hint',
  /** Left scrolling column (first half of the standings). */
  columnLeft: 'squad-tv-column-left',
  /** Right scrolling column (second half of the standings). */
  columnRight: 'squad-tv-column-right',
} as const;
